import GameCard from './GameCard';
import { useGames } from '../../context/GamesContext';
export default function Games() {
  const { games, loading, error, failedCount, retry } = useGames();
  return <div className="games-container">
    {loading && <p role="status">Carregando jogos...</p>}
    {error && <div role="alert"><p>{error}</p><button onClick={retry}>Tentar novamente</button></div>}
    {!loading && !error && !games.length && <p>Nenhum jogo disponível no momento.</p>}
    {failedCount > 0 && <div role="status"><p>Alguns jogos não puderam ser carregados.</p><button onClick={retry}>Tentar novamente</button></div>}
    {games.map(game => <GameCard key={game.id} game={game} />)}
  </div>;
}
